CH.getCookie = function(a) {
    var d = [];
    var e = document.cookie.split(";");
    var f;
    a = RegExp("^\\s*" + a + "=\\s*(.*?)\\s*$");
    for(var b = 0; b < e.length; b++) {
        f = e[b].match(a);
        f && d.push(f[1])
    }
    return d.length ? d[0] : null;
};

CH.setCookie = function(c_name, value, exdays) {
    var exdate;
    var expireString = "";
    if (exdays !== "session") {
        exdate = new Date();
        exdate.setDate(exdate.getDate() + (exdays ? exdays : 365));
        expireString = "expires=" + exdate.toUTCString() + ";";
    }
    document.cookie = c_name
        + "="
        + escape(value)
        + ";"
        + expireString
        + "domain=."
        + window.location.host
        + ";path=/";
};

/**
 * Check if this is a user's first visit to the site
 *
 * @return  {boolean}
 */
CH.isFirstVisit = (function() {
    /**
     * Is this a user's first visit?
     * @type {boolean}
     */
    var isFirstVisit = false;

    /**
     * Did we check their first visit cookie already?
     * @type {boolean}
     */
    var isChecked = false;

    /**
     * Do the check
     * @returns {boolean}
     */
    var checkCookie = function() {
        if (!isChecked) {
            if (!CH.getCookie('ch_landing')) {
                CH.setCookie('ch_landing', window.location.pathname);
                isFirstVisit = true;
            }
            isChecked = true;
        }
        return isFirstVisit;
    }

    // initialize
    checkCookie();

    return checkCookie;
})();

define("ch_cookie", function(){});

